// extracted by mini-css-extract-plugin
export default {"about":"About_about__NvFa2"};